import React, { Component } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Grid
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import YoutubeWidget from "../../widget/YoutubeWidget";
import VimeoWidget from "../../widget/VimeoWidget";
import SoundCloudWidget from "../../widget/SoundCloudWidget";
import SpotifyWidget from "../../widget/SpotifyWidget";
import "./ActMediaModal.css";

const youtubeReg = /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)/i;
const vimeoReg = /^https?:\/\/(www\.)?(vimeo\.com|player\.vimeo\.com)/i;
const soundcloudReg = /^https?:\/\/(www\.)?(soundcloud\.com|w\.soundcloud\.com)/i;
const spotifyReg = /^https?:\/\/(open\.spotify\.com)/i;
const facebookVideoReg = /^https?:\/\/(www\.)?(facebook\.com|fb\.watch)/i;
const tiktokReg = /^https?:\/\/(www\.)?(tiktok\.com|vm\.tiktok\.com)/i;

const parseVideoUrlString = (urlString) => {
    if (!urlString || typeof urlString !== 'string') return [];
    return urlString
        .split(" ||| ")
        .map(url => url.trim())
        .filter(url => url.length > 0)
        .map((url, index) => ({ id: `video-${index}`, url }));
};

class ActMediaModal extends Component {
    renderVideo = (video, index) => {
        const url = video.url || video;
        if (url.match(youtubeReg)) {
            return <YoutubeWidget key={index} url={url} />;
        } else if (url.match(vimeoReg)) {
            return <VimeoWidget key={index} url={url} height="300px" />;
        } else if (url.match(facebookVideoReg)) {
            return (
                <div key={index} className="facebook-video-embed" style={{ background: '#333', padding: '20px', borderRadius: '8px', textAlign: 'center', color: '#fff' }}>
                    <Typography variant="body2">Facebook Video</Typography>
                    <Typography variant="caption" style={{ wordBreak: 'break-all' }}>{url}</Typography>
                </div>
            );
        } else if (url.match(tiktokReg)) {
            return (
                <div key={index} className="tiktok-video-embed" style={{ background: '#333', padding: '20px', borderRadius: '8px', textAlign: 'center', color: '#fff' }}>
                    <Typography variant="body2">TikTok Video</Typography>
                    <Typography variant="caption" style={{ wordBreak: 'break-all' }}>{url}</Typography>
                </div>
            );
        }
        return null;
    };

    renderMusic = (url) => {
        if (!url) return null;
        if (url.match(soundcloudReg)) {
            return <SoundCloudWidget url={url} />;
        }
        if (url.match(spotifyReg)) {
            return <SpotifyWidget url={url} />;
        }
        return null;
    };

    render() {
        const { open, onClose, title, url, type } = this.props;

        const videoUrls = type === "video" ? parseVideoUrlString(url) : [];
        const hasVideos = videoUrls.length > 0;

        return (
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                className="act-media-modal"
            >
                <DialogTitle disableTypography className="modal-title">
                    <Typography variant="h6">{title || "Media"}</Typography>
                    <IconButton onClick={onClose} className="close-button">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="modal-content">
                    {type === "video" && hasVideos && (
                        <Grid container spacing={16}>
                            {videoUrls.map((video, index) => (
                                <Grid item xs={12} sm={videoUrls.length === 1 ? 12 : 6} key={video.id || index}>
                                    {this.renderVideo(video, index)}
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {type === "music" && url && (
                        <div className="media-container">
                            {this.renderMusic(url)}
                        </div>
                    )}

                    {!hasVideos && type === "video" && (
                        <Typography variant="body2" color="textSecondary">
                            No video available.
                        </Typography>
                    )}

                    {type === "music" && !url && (
                        <Typography variant="body2" color="textSecondary">
                            No music available.
                        </Typography>
                    )}
                </DialogContent>

                <DialogActions className="modal-actions">
                    <div />
                    <Button onClick={onClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ActMediaModal;
